import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import App from './App';
import './index.css';
import './config/axiosClient';
import { GlobalStyles, theme } from '@bpba/ui-components';
import { TurnstileProvider } from './config/TurnstileProvider';
import { TURNSTILE_ENABLED } from './constants/settings';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <TurnstileProvider siteKey={process.env.REACT_APP_TURNSTILE_KEY!} enabled={TURNSTILE_ENABLED}>
        <App />
      </TurnstileProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
